import { render, staticRenderFns } from "./PromotionDetailPerStore.vue?vue&type=template&id=4e680cb4&scoped=true"
import script from "./PromotionDetailPerStore.vue?vue&type=script&lang=js"
export * from "./PromotionDetailPerStore.vue?vue&type=script&lang=js"
import style0 from "./PromotionDetailPerStore.vue?vue&type=style&index=0&id=4e680cb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e680cb4",
  null
  
)

export default component.exports